 function servicios() {
    const servList = document.querySelector(".services-list");
    const servicios = servList.querySelectorAll("li");
    const desc = document.querySelector(".services-desc");

    servicios.forEach((s) => {
      s.addEventListener("mouseenter", () => {
        const service = s.getAttribute("data-serv");
        const txt = desc.querySelector(`.txt[data-serv="${service}"]`);

        // Ocultar todos los textos primero
        const allTxts = desc.querySelectorAll(".txt");
        allTxts.forEach((item) => {
          item.classList.remove("active");
        });

        // Mostrar solo el texto seleccionado
        txt.classList.add("active");
      });
    });

    servList.addEventListener("mouseleave", () => {
      const allTxts = desc.querySelectorAll(".txt");
      const txtFirst = desc.querySelector(".txt:first-child");

      // Ocultar todos los textos
      allTxts.forEach((txt) => {
        txt.classList.remove("active");
      });

      // Mostrar solo el primer texto
      txtFirst.classList.add("active");
    });
  }

  export default servicios